// src/taskpane/features/integrations/services/dartsipService.ts

import { DartsIPSearchParams, DartsIPResponse, JurisprudenceCase } from '../types/integrationTypes';

// Mock data
const MOCK_CASES: JurisprudenceCase[] = [
  {
    case_id: "000066729",
    title: "Viña Zara (Fig.) vs ZARA (Word) — Cancellation decision",
    ip_type: "EUTM",
    procedure_type: "cancellation",
    jurisdiction: "EU",
    court: "EUIPO",
    decision_date: "2025-12-10",
    decision_status: "final",
    parties: {
      applicant: ["Viña Zara (Figurative)"],
      opponent: ["ZARA (Word)"]
    },
    outcome: {
      result: "EUTM cancelled",
      winner: "applicant"
    },
    relevance_analysis: {
      relevance_score: 0.91,
      similarity_factors: {
        procedure_match: true,
        legal_issue_match: true,
        jurisdiction_match: true,
        industry_match: true
      }
    },
    legal_points: [
      {
        code: "norms",
        description: "Applied rules",
        importance_score: 0.9,
        excerpt: "Article 60(1)(a) EUTMR, Article 8(1)(b) CTMR"
      }
    ],
    ai_summary: {
      short: "Trademark 018959596; cancelled classes 33; not appealed.",
      practical_impact: "EUTM cancelled in invalidity proceedings.",
      success_factor: "Final decision without appeal."
    },
    documents: [
      {
        type: "decision",
        language: "en",
        pages: 1,
        format: "pdf",
        url: "https://fdftmhtvpvyifwutqkwd.supabase.co/storage/v1/object/public/documents/demo/20251210_000066729_VinaZara(Figurative)vsZARA(Word).pdf"
      }
    ]
  },
  {
    case_id: "003184071",
    title: "YAZARA (Word) vs ZARA (Word) — Opposition",
    ip_type: "IR designating the EU",
    procedure_type: "opposition",
    jurisdiction: "EU",
    court: "EUIPO",
    decision_date: "2025-10-20",
    decision_status: "final",
    parties: {
      applicant: ["YAZARA (Word)"],
      opponent: ["ZARA (Word)"]
    },
    outcome: {
      result: "EUTMA/IR refused",
      winner: "opponent"
    },
    relevance_analysis: {
      relevance_score: 0.88,
      similarity_factors: {
        procedure_match: true,
        legal_issue_match: true,
        jurisdiction_match: true,
        industry_match: true
      }
    },
    legal_points: [
      {
        code: "norms",
        description: "Applied rules",
        importance_score: 0.88,
        excerpt: "Article 8(1)(b) EUTMR, Article 8(5) EUTMR"
      }
    ],
    ai_summary: {
      short: "Trademark W01675812; classes 9, 36 and 42; not appealed.",
      practical_impact: "IR refused in the EU due to opposition.",
      success_factor: "Application of Articles 8(1)(b) and 8(5)."
    },
    documents: [
      {
        type: "decision",
        language: "en",
        pages: 1,
        format: "pdf",
        url: "https://fdftmhtvpvyifwutqkwd.supabase.co/storage/v1/object/public/documents/demo/20251020_003184071_YAZARA(Word)vsZARA(Word).pdf"
      }
    ]
  },
  {
    case_id: "R0391/2025-5",
    title: "ZAÏA (fig.) / ZARA et al. — Appeal decision",
    ip_type: "EUTM",
    procedure_type: "appeal",
    jurisdiction: "EU",
    court: "EUIPO Board of Appeal",
    decision_date: "2025-10-20",
    decision_status: "appealed",
    parties: {
      applicant: ["ZAÏA (fig.)"],
      opponent: ["ZARA et al."]
    },
    outcome: {
      result: "decision partially annulled",
      winner: "applicant"
    },
    relevance_analysis: {
      relevance_score: 0.92,
      similarity_factors: {
        procedure_match: true,
        legal_issue_match: true,
        jurisdiction_match: true,
        industry_match: true
      }
    },
    legal_points: [
      {
        code: "norms",
        description: "Normas aplicadas",
        importance_score: 0.92,
        excerpt: "Article 35(5) EUTMDR, Article 8(1)(b) EUTMR, Article 8(5) EUTMR, Article 95(2) EUTMR, Article 27(4) EUTMDR"
      },
      {
        code: "keywords",
        description: "Keywords",
        importance_score: 0.86,
        excerpt: "Likelihood of confusion (Yes), Reputation (Yes), Multiple applications, Unfair advantage (Yes), Due cause (No), Market practice, Belated evidence accepted"
      }
    ],
    ai_summary: {
      short: "Marca 018895325; clases 25, 30, 39, 45 vs 25, 30, 39, 43, 45.",
      practical_impact: "Decisión parcialmente anulada; recurso ante el GC.",
      success_factor: "Evaluación conjunta de confusión y reputación."
    },
    documents: [
      {
        type: "decision",
        language: "en",
        pages: 1,
        format: "pdf",
        url: "https://fdftmhtvpvyifwutqkwd.supabase.co/storage/v1/object/public/documents/demo/20251020_R0391_2025-5_ZAIA(Figurative)vsZARA.pdf"
      }
    ]
  },
  {
    case_id: "003207686",
    title: "LAZZARA (Figurative) vs ZARA (Word) — Opposition",
    ip_type: "EUTM",
    procedure_type: "opposition",
    jurisdiction: "EU",
    court: "EUIPO",
    decision_date: "2025-01-29",
    decision_status: "final",
    parties: {
      applicant: ["LAZZARA (Figurative)"],
      opponent: ["ZARA (Word)"]
    },
    outcome: {
      result: "partially refused EUTMA/IR",
      winner: "opponent"
    },
    relevance_analysis: {
      relevance_score: 0.86,
      similarity_factors: {
        procedure_match: true,
        legal_issue_match: true,
        jurisdiction_match: true,
        industry_match: true
      }
    },
    legal_points: [
      {
        code: "norms",
        description: "Normas aplicadas",
        importance_score: 0.87,
        excerpt: "Article 8(1)(b) EUTMR, Article 8(5) EUTMR"
      }
    ],
    ai_summary: {
      short: "Marca 018923447; clases 12, 36, 37, 39, 40 y 42; no apelado.",
      practical_impact: "Solicitud parcialmente rechazada por oposición.",
      success_factor: "Aplicación de artículos 8(1)(b) y 8(5)."
    },
    documents: [
      {
        type: "decision",
        language: "en",
        pages: 1,
        format: "pdf",
        url: "https://fdftmhtvpvyifwutqkwd.supabase.co/storage/v1/object/public/documents/demo/20250129_003207686_LAZZARA(Figurative)vsZARA(Word).pdf"
      }
    ]
  }
];

class DartsIPService {
  /**
   * Búsqueda de jurisprudencia en DartsIP (mockeado)
   */
  async searchJurisprudence(params: DartsIPSearchParams): Promise<DartsIPResponse> {
    // Simular delay de API
    await new Promise(resolve => setTimeout(resolve, 800));

    // Filtrar casos basados en parámetros básicos (simulación simple)
    let filteredCases = [...MOCK_CASES];

    if (params.basic_search?.keywords && params.basic_search.keywords.length > 0) {
      const keywords = params.basic_search.keywords.map(k => k.toLowerCase());
      filteredCases = filteredCases.filter(c => 
        keywords.some(keyword => 
          c.title.toLowerCase().includes(keyword) ||
          c.legal_points?.some(lp => lp.description.toLowerCase().includes(keyword)) ||
          c.ai_summary?.short.toLowerCase().includes(keyword)
        )
      );
    }

    if (params.basic_search?.jurisdiction && params.basic_search.jurisdiction.length > 0) {
      filteredCases = filteredCases.filter(c => 
        params.basic_search!.jurisdiction!.includes(c.jurisdiction)
      );
    }

    if (params.advanced_search?.procedure_type && params.advanced_search.procedure_type.length > 0) {
      filteredCases = filteredCases.filter(c => 
        params.advanced_search!.procedure_type!.includes(c.procedure_type)
      );
    }

    if (params.advanced_search?.courts && params.advanced_search.courts.length > 0) {
      filteredCases = filteredCases.filter(c => 
        params.advanced_search!.courts!.includes(c.court)
      );
    }

    // Ordenar por relevance score si está disponible
    if (params.sorting?.field === 'relevance_score') {
      filteredCases.sort((a, b) => {
        const scoreA = a.relevance_analysis?.relevance_score || 0;
        const scoreB = b.relevance_analysis?.relevance_score || 0;
        return params.sorting!.order === 'desc' ? scoreB - scoreA : scoreA - scoreB;
      });
    }

    const page = params.pagination?.page || 1;
    const pageSize = params.pagination?.page_size || 25;
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedResults = filteredCases.slice(startIndex, endIndex);

    return {
      request_id: `req_${Math.random().toString(36).substr(2, 9)}`,
      timestamp: new Date().toISOString(),
      metadata: {
        total_results: filteredCases.length,
        page,
        page_size: pageSize,
        total_pages: Math.ceil(filteredCases.length / pageSize),
        processing_time_ms: 423
      },
      results: paginatedResults,
      statistics: {
        success_rate_for_opponents: 0.61,
        average_decision_duration_months: 14.3,
        top_courts: [
          "EUIPO Board of Appeal",
          "General Court",
          "Audiencia Provincial"
        ]
      },
      recommendations: {
        overall_case_strength_score: 0.78,
        strategy_notes: [
          "Focus on territorial scope of evidence",
          "Highlight lack of continuous commercial use",
          "Avoid relying solely on internal documents"
        ]
      }
    };
  }
}

export const dartsipService = new DartsIPService();

